<template>
<tr v-if="showSocialIcons" :style="elParent" >
    <td :align="elAlign" :style="elChild" v-if="showNetwork('website')"> <a :href="openUrl($util.sanitizar(preview?.info?.website ?? null,'http://'))" target="_blank"><img :src="iconUrl('url')" :data-network="'url'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('facebook')"> <a :href="openUrl($util.sanitizar(preview?.info?.facebook ?? null,'facebook'))"  target="_blank"><img :src="iconUrl('facebook')" :data-network="'facebook'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('twitter')"> <a :href="openUrl($util.sanitizar(preview?.info?.twitter ?? null,'twitter'))" target="_blank"><img :src="iconUrl('twitter')" :data-network="'twitter'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('linkedin')"> <a :href="openUrl($util.sanitizar(preview?.info?.linkedin ?? null,'linkedin'))" target="_blank"><img :src="iconUrl('linkedin')" :data-network="'linkedin'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('instagram')"> <a :href="openUrl($util.sanitizar(preview?.info?.instagram ?? null,'instagram'))" target="_blank"><img :src="iconUrl('instagram')" :data-network="'instagram'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('youtube')"> <a :href="openUrl($util.sanitizar(preview?.info?.youtube ?? null,'youtube'))" target="_blank"><img :src="iconUrl('youtube')" :data-network="'youtube'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('vimeo')"> <a :href="openUrl($util.sanitizar(preview?.info?.vimeo ?? null,'vimeo'))" target="_blank"><img :src="iconUrl('vimeo')" :data-network="'vimeo'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('skype')"> <a :href="openUrl(preview?.info?.skype ?? null,'skype')" target="_blank"><img :src="iconUrl('skype')" :data-network="'skype'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('github')"> <a :href="openUrl(preview?.info?.github,'github')" target="_blank"><img :src="iconUrl('github')" :data-network="'github'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('spotify')"> <a :href="openUrl(preview?.info?.spotify,'spotify')" target="_blank"><img :src="iconUrl('spotify')" :data-network="'spotify'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('behance')"> <a :href="openUrl(preview?.info?.behance,'behance')" target="_blank"><img :src="iconUrl('behance')" :data-network="'behance'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('tiktok')"> <a :href="openUrl(preview?.info?.tiktok,'tiktok')" target="_blank"><img :src="iconUrl('tiktok')" :data-network="'tiktok'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('line')"> <a :href="openUrl(preview?.info?.line,'line')" target="_blank"><img :src="iconUrl('line')" :data-network="'line'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('telegram')"> <a :href="openUrl(preview?.info?.telegram,'telegram')" target="_blank"><img :src="iconUrl('telegram')" :data-network="'telegram'" @error="onIconError" width="16" height="16" /></a></td>
    <td :align="elAlign" :style="elChild" v-if="showNetwork('googlemaps')"> <a :href="openUrl($util.sanitizar(preview?.info?.googlemaps ?? null,'googlemaps'))" target="_blank"><img :src="iconUrl('map')" :data-network="'map'" @error="onIconError" width="16" height="16" /></a></td>
</tr>
</template>
<script>
import { getSignatureIconUrl } from '@/features/signatures/utils/iconUrl.js';

export default {
    props:['parent','child','align','linkcard','signature'],
    data() {
        return {
            url_node:'https://api.linkcard.app/api/signature',
            elParent:this.padre,
            elChild:this.child,
            elAlign:this.align,
            signa:this.signature,
            preview:this.linkcard
        }
    },
    methods: {
        iconUrl(network) {
            return getSignatureIconUrl(network, this.signa?.color_redes, this.url_node);
        },
        onIconError(event) {
            const img = event.target;
            if (img.dataset.fallbackApplied) return;
            img.dataset.fallbackApplied = '1';
            const network = img.dataset.network;
            if (network) {
                img.src = getSignatureIconUrl(network, null, this.url_node);
            }
        },
        showNetwork(field) {
            if (!this.showSocialIcons) return false;
            const previewPlaceholderFields = [
                "website",
                "facebook",
                "twitter",
                "linkedin",
                "instagram",
                "youtube",
            ];
            if (!this.preview) {
            return previewPlaceholderFields.includes(field);
            }
            return !!(this.preview.info && this.preview.info[field]);
        },
        getUrl(){
            if(process.client)return window.location
        },
 
        openUrl(url) {
            if(typeof url == 'string' && url.includes('mailto:')){
                 url+='?subject='+this.$t('general.whatsmsg')
            }
            return url
        },
    },
    computed:{
        showSocialIcons() {
            return (this.signa?.template_id ?? 0) > 2;
        },
    }
}
</script>
